module.exports = __webpack_public_path__ + "static/img/yuerdx_default@3x.4459b4a7.png";